// import './BmTabBar.less';
import './BmTabBar.less';
export const prefix = 'bm-c-tab-bar';

export { default } from './BmTabBar';
